<div
  style="width: -webkit-fit-content; width: -moz-fit-content; width: fit-content; margin-left: auto; margin-right: 10px;">
  <button
    statistic
    statisticElementName="Click Moneyness in Volatility Surface"
    (click)="changeSurfaceType('moneyness')"
    [class.active]="type=='moneyness'"
    class="iv-inline-button">
    Moneyness
  </button>
</div>

<div *ngIf="tableDataSize > 0" class="surface-data-table-container">
  <table class="surface-data-table">
    <tr>
      <td>&#160;</td>
      <td *ngFor="let value of values">{{value | number:'1.0-2'}}</td>
    </tr>

    <tr *ngFor="let period of periods">
      <td>
        {{period}}
      </td>
      <td *ngFor="let dt of tableData[period]">
        {{dt.iv | number:'1.0-2'}}
      </td>
    </tr>
  </table>
</div>

<div>
  <div id="ivSurface"></div>
</div>
